/* eslint-disable no-console */

// import { register } from 'register-service-worker'

// if (process.env.NODE_ENV === 'production') {
//   register(`${process.env.BASE_URL}service-worker.js`, {
//     ready () {
//       console.log(
//         'App is being served from cache by a service worker.\n' +
//         'For more details, visit https://goo.gl/AFskqB'
//       )
//     },
//     registered () {
//       console.log('Service worker has been registered.')
//     },
//     cached () {
//       console.log('Content has been cached for offline use.')
//     },
//     updatefound () {
//       console.log('New content is downloading.')
//     },
//     updated () {
//       console.log('New content is available; please refresh.')
//     },
//     offline () {
//       console.log('No internet connection found. App is running in offline mode.')
//     },
//     error (error) {
//       console.error('Error during service worker registration:', error)
//     }
//   })
// }
// src/registerServiceWorker.js

// Check if service workers are supported by the browser
if ('serviceWorker' in navigator) {
  // Wait for the window to fully load before attempting registration
  window.addEventListener('load', () => {
    // Register the service worker file. The path is relative to the origin,
    // so '/sw.js' assumes your sw.js is in the root of your deployed site (e.g., /public/sw.js).
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        // Service worker registration was successful!
        console.log('Service Worker registered with scope:', registration.scope);
        // You might want to add listeners here for updates or other lifecycle events
      })
      .catch(error => {
        // Service worker registration failed
        console.error('Service Worker registration failed:', error);
      });
  });
} else {
  // Service workers are not supported in this browser
  console.log('Service Workers not supported in this browser.');
}
